























































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import {API} from '@/services/api/api';
import {Utils} from '@/utils/Utils';
import {mapActions} from 'vuex';
import {redirectTime, acceptedImageTypes} from '@/constants/constants';
import {extractDetailsFromBase64, mergeBase64toImage} from '@/services/api/image';
import {getUserCompanyId} from '@/services/api/user';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class EditLogo extends Vue {
  //store variables
  showSuccessToast: any;
  showErrorToast: any;

  //form variables
  imageValidationMsg: any = null;
  imageName: any = null;
  imageStatus: any = null;
  imagebase64URL = '';
  logoId: any = null;
  name = '';
  acceptedImageTypes = acceptedImageTypes;

  //loader variables
  loadingBtnStatus = false;
  isScreenLoading = true;

  mounted() {
    this.logoId = this.$route.params.id;

    this.getLogoDetails();
  }

  //get particular logo details
  async getLogoDetails() {
    try {
      let apiResponse = await API.getLogoDetailsById(this.logoId);
      if (apiResponse.data) {
        const data = apiResponse.data;
        this.imageName = data.logoName;
        this.name = data.logoCaption; //waiting LogoCaption
        this.imageStatus = data.logoIsActive;
        this.imagebase64URL = mergeBase64toImage(data.imageType, data.logoImage);
      } else {
        this.showErrorToast({msg: apiResponse.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  //convert image into base 64 string and display on screen
  async onFileChange(event: any) {
    const imageData = event.target.files[0];
    this.imageName = imageData.name;

    try {
      let base64url = await Utils.ngxBase64(imageData);
      if (base64url === null) alert('Something went wrong with image');
      else {
        this.imageValidationMsg = null;
        return (this.imagebase64URL = base64url);
      }
    } catch (error) {
      // console.error(error);
      return 'Something went wrong';
    }
  }

  validateImage() {
    if (this.imageName === null || this.imagebase64URL === null) {
      this.imageValidationMsg = 'Please choose image first. ';
      return false;
    } else {
      this.imageValidationMsg = null;
      return true;
    }
  }

  //submit button handler
  async _updateHandler() {
    if (!this.validateImage()) {
      return false;
    }
    try {
      this.loadingBtnStatus = true;
      const companyid = getUserCompanyId();
      const {imageType, url} = extractDetailsFromBase64(this.imagebase64URL);
      const formData = {
        logoisactive: this.imageStatus,
        logoname: this.imageName,
        logocaption: this.name,
        logoimage: url,
        imagetype: imageType,
        companyid,
      };
      let response = await API.updateLogoDetailsById(this.logoId, formData);

      if (response.data) {
        let message: string = response.message;
        if (message.includes('updated logo')) {
          message = 'Record updated successfully';
        }
        this.showSuccessToast({msg: message});
        setTimeout(() => this.handleClick(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.loadingBtnStatus = false;
    }
  }

  handleClick() {
    this.$router.go(-1);
  }
}
